module.exports = __webpack_public_path__ + "static/img/14000795.4e1b0e97.png";